// extracted by mini-css-extract-plugin
module.exports = {"gst-information-footer":"product-tax-disclaimer-message_gst-information-footer___2Pd8"};